<template>
  <div class="wrap-hbt-booking">
    <service-room
      class-name="flex flex-col gap-2 sm:gap-3 sm:px-4 sm:py-6"
    ></service-room>

    <div class="separator-space lg:hidden md:hidden"></div>

    <div class="flex flex-col items-end sm:px-4 sm:py-6 mdsm:w-full">
      <div class="mb-2">
        Total:
        <span class="fs-24 font-medium">
          <currency-context v-if="getTotalBooking">
            <template v-slot="{ convert }">
              <span v-text="convert(getTotalBooking)"></span>
            </template>
          </currency-context>
          <span v-else>-</span>
        </span>
      </div>
      <div class="flex items-center">
        <div class="mr-2 text-black-light-5 fs-14">
          {{
            `For ${totalGuests()} in ${this.bookingRooms.length} ${
              this.bookingRooms.length > 1 ? "rooms" : "room"
            }, ${totalDays(true)} nights`
          }}
        </div>
        <span class="mdsm:hidden">|</span>
        <div
          @click="handlePriceDetailsModal(true)"
          class="text-secondary font-medium cursor-pointer ml-2 mdsm:hidden"
        >
          See price details
        </div>
      </div>
      <button
        @click="continueToReserve"
        :disabled="getSelectedRoomDetails.length < groupsResult.length"
        class="btn btn-primary w-fit-content mt-5 px-5 py-4 sm:py-3 sm:w-full"
      >
        Continue to reserve
      </button>
      <div class="mt-2 fs-14 sm:mt-3 sm:italic sm:text-center sm:w-full">
        <span class="lg:hidden">*</span>Price includes transfers, taxes, and
        service fees
      </div>
    </div>

    <price-details-modal
      :show-price-details="showPriceDetailsModal"
      @close="handlePriceDetailsModal(false)"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CurrencyContext from "../../core/CurrencyContext";
import BookingInvoice from "./BookingInvoice";
import { guestsDisplay } from "../../../helpers/hummingbirdHelpers";
import { tryParse, totalDays } from "../../../helpers";
import ServiceRoom from "./ServiceRoom";

export default {
  components: {
    CurrencyContext,
    BookingInvoice,
    ServiceRoom,
  },
  data() {
    return {
      supplier: null,
      showError: false,
    };
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((response) => {
      this.supplier = response.supplier;
    });
  },
  computed: {
    ...mapState([
      "bookingDates",
      "bookingRooms",
      "groupsResult",
      "showPriceDetailsModal",
    ]),
    ...mapGetters(["getAllState", "getSelectedRoomDetails", "getTotalBooking"]),
  },
  methods: {
    continueToReserve() {
      if (this.bookingRooms.length > this.getSelectedRoomDetails.length) {
        this.showError = true;
      } else {
        this.showError = false;

        const data = {
          dates: [
            moment(this.bookingDates[0]).format("YYYY-MM-DD"),
            moment(
              this.bookingDates[1] ? this.bookingDates[1] : this.bookingDates[0]
            ).format("YYYY-MM-DD"),
          ],
          ...this.getAllState,
        };

        localStorage.setItem("hbtResortData", JSON.stringify(data));
        window.location.href = "/booking";
      }
    },
    totalGuests() {
      return guestsDisplay(this.bookingRooms);
    },
    totalDays(nights = false) {
      const fromDate = this.bookingDates[0];
      const toDate = this.bookingDates[1];

      if (fromDate && toDate) {
        return totalDays(fromDate, toDate, nights);
      } else if (fromDate && !toDate) {
        return totalDays(fromDate, fromDate);
      }

      return "";
    },
    handlePriceDetailsModal(value) {
      this.$store.commit("setShowPriceDetailsModal", value);
    },
  },
};
</script>

<style scoped>
.wrap-hbt-booking {
  display: flex;
  justify-content: space-between;
  padding: 24px 32px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 0px 0px 4px 4px;
  border: 1px solid #dcdcdc;
  border-top: none;
  background: #f5f9fc;
}

.separator-space {
  height: 16px;
  background-color: #fff;
  width: 100%;
}

@media (max-width: 600px) {
  .wrap-hbt-booking {
    border: 0px;
    padding: 0px;
    flex-direction: column-reverse;
  }
}
</style>
